import mod from "-!./smeta.js?vue&type=script&lang=js&external"; export default mod; export * from "-!./smeta.js?vue&type=script&lang=js&external"